export default {"src":"/_next/static/media/chatBubbleWithDots_64.c1842d96.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};